import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export default function NotFoundPage() {
  return (
    <div className="bg-ink min-h-screen text-cream" data-testid="not-found-page">
      <Navbar />
      <div className="pt-44 pb-28 text-center px-4">
        <Compass size={44} className="text-gold mx-auto mb-6" strokeWidth={1.5} />
        <h1 className="font-display text-4xl sm:text-5xl mb-4">This page wandered off the map.</h1>
        <p className="text-mist text-sm sm:text-base mb-8">The page you're looking for doesn't exist — but your next journey does.</p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="inline-flex items-center gap-2 bg-gold text-ink font-semibold text-sm px-8 py-4 rounded-full hover:bg-gold-hover transition-colors"
        >
          Back to home
        </Link>
      </div>
      <Footer />
    </div>
  );
}
